/** Sort advertisements newest first (updatedAt, then createdAt, then id). */
export function sortAdvertisementsByDate(list) {
  return [...(list || [])].sort((a, b) => {
    const aUpdated = new Date(a?.updatedAt || a?.updated_at || 0).getTime();
    const bUpdated = new Date(b?.updatedAt || b?.updated_at || 0).getTime();
    if (bUpdated !== aUpdated) return bUpdated - aUpdated;

    const aCreated = new Date(a?.createdAt || a?.created_at || 0).getTime();
    const bCreated = new Date(b?.createdAt || b?.created_at || 0).getTime();
    if (bCreated !== aCreated) return bCreated - aCreated;

    return Number(b?.id || 0) - Number(a?.id || 0);
  });
}
